import { render, staticRenderFns } from "./ListSPRPage.vue?vue&type=template&id=ecc51808&scoped=true&"
import script from "./ListSPRPage.vue?vue&type=script&lang=js&"
export * from "./ListSPRPage.vue?vue&type=script&lang=js&"
import style0 from "./ListSPRPage.vue?vue&type=style&index=0&id=ecc51808&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecc51808",
  null
  
)

export default component.exports